import Cropper from 'cropperjs';
import NotificationManager from "../../utils/class/notifications";

export default function Photo () {
  const _NotificationManager = new NotificationManager();

  const form = document.querySelector('#project-creation-form');
  if (!form) return;

  const dropArea = form.querySelector('#drop-area');
  if (!dropArea) return;

  const input = form.querySelector('input[type="file"]');
  if (!input) return;

  const inputURL = form.querySelector('input#cover-image-url');
  if (!inputURL) return;

  const reset = form.querySelector('#reset-cover-image');
  if (!reset) return;

  const attach = form.querySelector('#attach-cover-image');
  if (!attach) return;

  const remove = form.querySelector('#remove-cover-image');
  if (!remove) return;

  const next = form.querySelector('#cover-image-validation');
  if (!next) return;

  const croppArea = form.querySelector('#photo-upload-result');
  if (!croppArea) return;

  const range = form.querySelector('input[type="range"]');
  if (!range) return;

  const preloader = form.querySelector('#attached-preloader');
  if (!preloader) return;

  const result = form.querySelector('#attached-image');
  if (!result) return;

  const controls = form.querySelector('#attached-controls');
  if (!controls) return;

  ['dragenter', 'dragover'].forEach((eventName) => {
    dropArea.addEventListener(eventName, (event) => {
      event.preventDefault();
      event.stopPropagation();

      dropArea.classList.add('highlight');
    });
  });

  ['dragleave', 'drop'].forEach((eventName) => {
    dropArea.addEventListener(eventName, (event) => {
      event.preventDefault();
      event.stopPropagation();

      dropArea.classList.remove('highlight');
    });
  });

  const container = form.querySelector('#image-container');
  if (!container) return;

  const image = form.querySelector('#image-to-crop');
  if (!image) return;

  let cropper = new Cropper(image);

  function uploadImage (event) {
    event.preventDefault();
    event.stopPropagation();

    preloader.classList.remove('hidden');

    const cropped = cropper.getCroppedCanvas({ width: 750, height: 350 });

    cropped.toBlob((blob) => {
      const formData = new FormData();

      formData.append('photo', blob);

      (async function () {
        try {
            await fetch(`/wp-json/projects/v1/upload-photo`, {
                method: 'POST',
                body: formData
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                  form.classList.remove('error');

                  _NotificationManager.sendNotification('success', 'Photo uploaded!', data.message);

                  dropArea.classList.add('hidden');
                  croppArea.classList.add('hidden');
              
                  if (cropper) {
                    cropper.destroy();
                  }
              
                  input.value = '';
                  inputURL.value = data.url;

                  setTimeout(() => inputURL.dispatchEvent(new Event('change')));

                  setTimeout(() => preloader.classList.add('hidden'), 1000);

                  result.innerHTML = `<img src="${data.url}">`;
                  result.classList.remove('hidden');

                  controls.classList.remove('hidden');

                  next.classList.remove('disabled');
              } else {
                preloader.classList.add('hidden');

                form.classList.add('error');

                _NotificationManager.sendNotification('error', 'An error occurred...', data.message);
              }
            })
            .catch(() => {
              preloader.classList.add('hidden');

              form.classList.add('error');

              _NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
            });
        } catch (error) {
          preloader.classList.add('hidden');

          form.classList.add('error');

          _NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
        }
      })();
    }, 'image/jpeg');
  }

  const handleFile = (file) => {
    attach.removeEventListener('click', uploadImage);

    next.classList.add('disabled');

    const reader = new FileReader();

    reader.onload = (event) => {
        image.src = event.target.result;

        if (cropper) {
            cropper.destroy();
        }

        dropArea.classList.add('hidden');
        croppArea.classList.remove('hidden');

        cropper = new Cropper(image, {
            aspectRatio: 15 / 7,
            dragMode: 'move',
            viewMode: 3,
            zoomOnWheel: false
        });

        range.addEventListener('input', (e) => {
            const { value } = e.target;

            const progress = (value / range.max) * 100;

            range.style.background = `linear-gradient(to right, #ff8244 ${progress}%, #d5d5d5 ${progress}%)`;

            cropper.zoomTo(value / 100);
        });
    };

    reader.readAsDataURL(file);

    attach.addEventListener('click', uploadImage);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const transfer = event.dataTransfer;
    const file = transfer.files[0];

    handleFile(file);
  };

  dropArea.addEventListener('change', (event) => {
    const file = event.target.files[0];

    handleFile(file);
  });

  dropArea.addEventListener('drop', handleDrop, false);

  remove.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    dropArea.classList.remove('hidden');
    croppArea.classList.add('hidden');

    range.style.background = `linear-gradient(to right, #ff8244 ${0}%, #d5d5d5 ${0}%)`;
    range.value = 0;

    next.classList.remove('disabled');

    if (cropper) {
      cropper.destroy();
    }

    input.value = '';
    inputURL.value = '';

    setTimeout(() => inputURL.dispatchEvent(new Event('change')));

    result.innerHTML = '';
    result.classList.add('hidden');

    controls.classList.add('hidden');
  });

  reset.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    dropArea.classList.remove('hidden');
    croppArea.classList.add('hidden');

    range.style.background = `linear-gradient(to right, #ff8244 ${0}%, #d5d5d5 ${0}%)`;
    range.value = 0;

    next.classList.remove('disabled');

    if (cropper) {
      cropper.destroy();
    }

    input.value = '';
  });

  /**
   * Preload Data
   */

  if (inputURL.value) {
    dropArea.classList.add('hidden');
    croppArea.classList.add('hidden');

    if (cropper) {
      cropper.destroy();
    }

    input.value = '';

    result.innerHTML = `<img src="${inputURL.value}">`;
    result.classList.remove('hidden');

    controls.classList.remove('hidden');
  }
}
